import Container from './StudioHeader.container';
import StudioHeader from './StudioHeader';

export default Container(StudioHeader);
